import { useSetAtom } from "jotai";
import { ReactNode, useCallback } from "react";
import { floatingToolbarActiveButtonAtom } from "@zapier/canvas-state";
import { BackButton } from "../BackButton";
import styles from "./WrapperWithBackButton.module.css";
import classNames from "classnames";

type Props = {
  children: ReactNode;
  showBackButton?: boolean;
  hasExtraTopPadding?: boolean;
};

export function WrapperWithBackButton({
  children,
  showBackButton = true,
  hasExtraTopPadding = false,
}: Props) {
  const setActiveButton = useSetAtom(floatingToolbarActiveButtonAtom);

  const returnToMainToolbar = useCallback(
    () => setActiveButton(null),
    [setActiveButton],
  );

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.extraTopPadding]: hasExtraTopPadding,
      })}
    >
      {showBackButton && <BackButton onClick={returnToMainToolbar} />}
      {children}
    </div>
  );
}
